import { Component } from 'react';
import ListBuilder from '../../../components/listBuilder';
import { API_ENDPOINT } from '../../../constants';
import { Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import InlineSVG from 'react-inlinesvg';
import addIcon from '../../../assets/svg/add-icon.svg';
import editIcon from '../../../assets/svg/edit.svg';
import deleteIcon from '../../../assets/svg/garbage.svg';
import useFormV2 from '../../../form-v2/form.hook';
import FormV2 from '../../../form-v2/form.component';
import useFetchData from '../../../hooks/fetch-data.hook';
import { useEffect } from 'react';
import { useState } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import Field from '../../../form-v2/field.component';
import ErrorModal from '../../../components/errorModal';
import DeleteModal from '../../../components/deleteModal';

function parseJSON(response) {
	return response.json().then(json => {
		return {
			result: json,
			status: response.status
		}
	})
}

const loadDataWithQuery = [
	(fetchFunction, lang, match, query) => {
		let url = `${API_ENDPOINT}/labportalen/e-remiss/templates?page=${query?.page ?? 0}&entries=${query?.entries ?? 10}&sortField=${query?.sortField ?? '_id'}&sortType=${query?.sortType ?? -1}&filter=${query?.filter ?? ''}&groupId=${query?.groupId ?? ''}&clinicId=${query?.clinicId ?? ''}`;

		return fetchFunction?.(url, {
			method: 'GET',
			headers: {
				'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
				'content-type': 'application/json'
			},
		}).then(parseJSON).then(({ result, status }) => {
			if (!result.error) {
				return {
					page: query.page ? query.page : 0,
					items: result.items,
					total: result.total,
					resultFilter: result.filter
				}
			}
			else return { error: result.error }
		})
	}
]

/**
 * @typedef {{
 *   selectedGroup: string;
 *   selectedClinic: string;
 *   departmentId?: string | number;
 *   lang: string;
 *   uData?: any;
 * }} Props
 */

/**
 * @class
 * @augments {Component<Props, State>}
 */
export default class LabPortalenRemissTemplates extends Component {
	/**
	* 
	* @param {Props} props 
	*/
	constructor(props) {
		super(props);

		this.state = {
			useState: true,
			params: {
				entries: 10,
				page: 0,
				sortField: '_id',
				sortType: -1,
				filter: ''
			},
			items: [],
			total: 0,
			loading: true,
			error: null,

			form: null,
			deleteId: null,
		};
	}

	get = () => {
		this.setState({ loading: true, error: null }, () => {
			for (let i = 0; i < loadDataWithQuery.length; i++) {
				loadDataWithQuery?.[i]?.(window?.fetch, this.props.lang, this.props[0].match, { ...this.state.params, groupId: this.props.selectedGroup, clinicId: this.props.selectedClinic }).then(data => {
					if (data?.error) return this.setState({ loading: null, error: data.error?.translate(this.props.lang || 'en') });

					this.setState({ ...data, loading: null });
				})
			}
		})
	}

	componentDidMount() {
		if (typeof window !== 'undefined') { window.scrollTo(0, 0); }

		this.get();
	}

	componentDidUpdate(prevProps, prevState) {
		if (!prevProps.selectedGroup && this.props.selectedGroup || prevProps.selectedGroup !== this.props.selectedGroup) this.get();

		if (prevProps?.num !== this.props.num) this.get();

		if (prevState?.params !== this.state.params) this.get();
	}

	updateSort = (field, type) => this.setState(prev => ({
		...prev,
		params: {
			...prev?.params,
			sortField: field,
			sortType: type
		}
	}));

	updateParams = (name, value, restart = false) => {
		let obj = {
			[name]: value
		}
		this.setState(prev => ({
			...prev,
			params: {
				...prev?.params,
				entries: restart ? 10 : prev.params.entries,
				page: restart ? 0 : prev.params.page,
				...obj
			}
		}));
	}

	updateMultipleParams = (fields, restart = false) => {
		let obj = {};
		if (restart) {
			obj.entries = 10;
			obj.page = 0;
		}
		for (let i = 0; i < fields.length; i++) {
			obj[fields[i].name] = fields[i].value;
		}
		return this.setState(prev => ({
			...prev,
			params: {
				...prev?.params,
				...obj
			}
		}));
	}

	deleteTemplate = () => {
		if (this.state.deleteId) {
			this.setState({ loading: true, error: null }, async () => {
				const response = await fetch(`${API_ENDPOINT}/labportalen/e-remiss/templates/${this.state.deleteId}`, {
					method: 'DELETE',
					headers: {
						'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
						'content-type': 'application/json'
					},
				});

				const result = await response.json();
				if (result.error) {
					this.setState({ loading: null, error: result.error?.translate(this.props.lang || 'en'), deleteId: null });
					return;
				}

				this.setState({ deleteId: null, loading: false }, () => {
					this.get();
				});
			})
		}
	}

	render() {
		let params = this.state.params;

		return <>
			<Row>
				<Col>
					<div className='panel'>
						<div style={{
							marginBottom: 40,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							gap: 10,
						}}>
							<h2 style={{
								fontSize: 22,
								textAlign: 'left',
								padding: 0,
								margin: 0,

							}}>
								<span>{'Lab Portalen e-Remiss Templates'.translate(this.props.lang)}</span>
							</h2>

							<button className="btn add-button" style={{
								display: 'flex',
								alignItems: 'center',
								gap: 10
							}} onClick={() => {
								this.setState({
									form: 'new'
								})
							}}>
								<InlineSVG src={addIcon} />
								{'Create New Template'.translate(this.props.lang)}
							</button>
						</div>

						<ListBuilder
							lang={this.props.lang}
							loading={this.state.loading}
							total={this.state.total}
							showNumeration={false}
							filterDelay={500}
							// uData={this.props.uData}
							fields={[
								{ type: 'text', name: 'name', label: 'Template Name'.translate(this.props.lang) }
							]}
							rawItems={this.state.items}
							items={this.state.items}
							actions={[
								{
									component: <div className="tabel-action-tooltip">
										<InlineSVG src={editIcon} />
										<div className="chat-icons-tooltip">{'Edit'.translate(this.props.lang)}</div>
									</div>,
									onClick: item => this.setState({ form: item?._id })
								},
								{
									component: <div className="tabel-action-tooltip">
										<InlineSVG src={deleteIcon} />
										<div className="chat-icons-tooltip">{'Delete'.translate(this.props.lang)}</div>
									</div>,
									onClick: item => this.setState({ deleteId: item?._id })
								}
							]}
							params={params}
							sortField={params.sortField}
							sortType={params.sortType}
							updateSort={this.updateSort}
							updateParams={this.updateParams}
							updateMultipleParams={this.updateMultipleParams}
						/>
					</div>
				</Col>
			</Row>

			{this.state.form ? <Modal
				key='labportalen-remiss-template-form-modal'
				isOpen={this.state.form}
				centered={true}
				size='lg'
				toggle={() => this.setState({ form: null })}
				backdrop='static'
			>
				<ModalHeader
					toggle={() => this.setState({ form: null })}
				>
					{this.state.form === 'new' ? 'Create New Template'.translate(this.props.lang) : 'Edit Template'.translate(this.props.lang)}
				</ModalHeader>
				<ModalBody style={{ padding: '0px' }}>
					<LabPortalenRemissTemplateForm
						lang={this.props.lang}
						id={this.state.form}
						onCancel={() => this.setState({ form: null })}
						onSubmit={() => {
							this.setState({ form: null }, () => {
								this.get();
							});
						}}
						groupId={this.props.selectedGroup}
						clinicId={this.props.selectedClinic}
					/>
				</ModalBody>
			</Modal> : null}

			{this.state.deleteId ? <DeleteModal
				key='labportalen-remiss-template-delete-modal'
				lang={this.props.lang}
				isOpen={this.state.deleteId}
				toggle={() => this.setState({ deleteId: null })}
				handler={this.deleteTemplate}
			>
				{'Are you sure you want to delete this template? This action cannot be undone.'.translate(this.props.lang || 'en')}
			</DeleteModal> : null}

			{this.state.error ? <ErrorModal key='labportalen-remiss-template-error-modal' isOpen={this.state.error} toggle={() => this.setState({ error: null })} size='md'>
				{typeof this.state.error === 'string' ? this.state.error.translate(this.props.lang || 'en') : 'Something went wrong! Please try again later.'.translate(this.props.lang || 'en')}
			</ErrorModal> : null}
		</>
	}
}

const LabPortalenRemissTemplateForm = ({
	lang,
	id,
	onCancel,
	onSubmit,

	groupId,
	clinicId
}) => {
	const [manuallyAddedContactPerson, setManuallyAddedContactPerson] = useState(false);
	const { data: labsData, isLoading: isLoadingLabs } = useFetchData(`/integrations/clinic/labportalen/labs/${groupId}`); // labs: {id: string; name: string}[]
	const { data: userData, isLoading: isLoadingUsers } = useFetchData(`/integrations/clinic/labportalen/users/${groupId}`); // users: {id: string; name: string;}[]

	const form = useFormV2({
		autoComplete: false,
		autoFetch: id === 'new' ? undefined : {
			url: `/labportalen/e-remiss/templates/${id}`,
		},
		autoSubmit: id === 'new' ? {
			method: 'post',
			url: `/labportalen/e-remiss/templates`,
			onBeforeSubmit: (data) => {
				data.groupId = groupId;
				data.clinicId = clinicId;
				return data;
			},
			onAfterSubmit: onSubmit,
		} : {
			method: 'put',
			url: `/labportalen/e-remiss/templates/${id}`,
			onAfterSubmit: onSubmit,
		},
		buttons: {
			reset: {
				isShown: true,
				text: 'Cancel',
				color: 'danger',
				callback: onCancel
			}
		},
		sections: {
			'1': {
				title: 'General Information'
			},
			'2': {
				title: 'Lab & Analysis Details'
			},
			'3': {
				title: 'Requisition Unit Details'
			},
			'4': {
				title: 'Pay Unit Details'
			},
			'5': {
				title: 'Additional Information'
			}
		},
		styles: {
			form: {
				margin: '0 0'
			}
		}
	}, {
		name: {
			type: 'text',
			label: 'Template Name',
			isRequired: true,
			section: '1',
		},
		isAcute: {
			type: 'checkbox',
			label: 'Acute Order',
			section: '1',
			info: 'If checked, the requisition will be marked as an acute order in Lab Portalen',
		},
		sendAsSampled: {
			type: 'checkbox',
			label: 'Send as Sampled',
			section: '1',
			info: 'Check this box if you want the referral to be sent to "Sampling View" in Lab Portalen. Leave unchecked if you want the referral to be sent to "Ordering View"',
		},
		type: {
			type: 'hidden',
			initialValue: 'send', // 'save' or 'send' // if needed - implement select later
		},

		labId: {
			type: 'select',
			label: 'Lab',
			isRequired: true,
			section: '2',
			config: {
				options: (_, e) => e?.labs?.map?.(lab => ({
					value: lab.id,
					label: lab.name
				}))
			},
			placeholder: 'Please select a lab',
			info: 'Select the Lab Portalen lab where the analysis will be sent. Make sure that you have order code set up for this lab! If you do not see any labs in the list, your connection with LabPortalen might not be set up correctly, please contact your clinic administrator',
			onChangeCallback: () => {
				form?.set?.('analyses', []);
			}
		},
		analyses: {
			type: 'custom',
			label: 'Analyses',
			isRequired: true,
			section: '2',
			initialValue: [],
			component: AnalysesCustomComponent,
			validator: (val) => {
				if (!val || !Array.isArray(val) || val.length === 0 || !val.every(v => v.AnalysisName && v.AnalysisCode)) return 'Please select at least one valid analysis for selected lab';

				return null;
			}
		},

		'reqUnit.orderCode': {
			type: 'text',
			label: 'Order Code',
			isRequired: true,
			section: '3',
			info: 'The order code provided by Lab Portalen for the requisition unit. Please ensure that this code is accurate and that it is setup to work with selected lab',
			cols: { lg: 6 }
		},
		'reqUnit.name': {
			type: 'text',
			label: 'Requisition Unit Name',
			isRequired: true,
			section: '3',
			cols: { lg: 6 }
		},
		'reqUnit.contactPerson': {
			type: 'text',
			label: 'Contact Person Name',
			isRequired: true,
			section: '3',
			cols: { lg: 6 },
			info: 'Name of the contact person for the this template. Leave this field empty if you want to automatically select from the user list next to this field, and this field will be automatically filled with the selected user name',
			onChangeCallback: (val, _, e) => {
				if (val && val.trim?.()) {
					e.setManuallyAddedContactPerson(true);
				} else {
					e.setManuallyAddedContactPerson(false);
				}
			}
		},
		'reqUnit.userGuid': {
			type: 'select',
			label: 'Default Remittent',
			config: {
				options: (_, e) => e?.users?.map?.(user => ({
					value: user.id,
					label: user.name
				}))
			},
			section: '3',
			cols: { lg: 6 },
			onChangeCallback: (value, _, e) => {
				if (value && e?.users && !e?.manuallyAddedContactPerson) {
					const user = e.users.find(u => u.id === value);
					if (user) {
						form?.set?.('reqUnit.contactPerson', user.name);
					}
				} else if (!value && !e?.manuallyAddedContactPerson) {
					form?.set?.('reqUnit.contactPerson', '');
				}
			},
			placeholder: 'Select default remittent',
			info: 'Use this field if you wish to select default remittent from the list of LabPortalen users. Leave empty and manually fill out "Contact Person Name" field if you wish to manually enter the contact person name',
		},
		'reqUnit.autoInsertDoctor': {
			type: 'checkbox',
			label: 'Add Caregiver as Remittent',
			section: '3',
			info: 'If checked, we will try to extract the caregiver from the case and automatically add them as the contact person on the requisition. If caregiver cannot be extracted, or their account from this portal is not synced with LabPortalen account, we will use the default remittent, if set above',
		},

		'payUnit.isSameAsReq': {
			type: 'checkbox',
			label: 'Pay Unit same as Requisition Unit',
			section: '4',
			initialValue: true,
		},
		'payUnit.orderCode': {
			type: 'text',
			label: 'Order Code',
			condition: (s, e) => s?.['payUnit.isSameAsReq']?.value === true ? false : true,
			isRequired: (s, e) => s?.['payUnit.isSameAsReq']?.value === true ? false : true,
			section: '4',
			cols: { lg: 6 }
		},
		'payUnit.name': {
			type: 'text',
			label: 'Pay Unit Name',
			condition: (s, e) => s?.['payUnit.isSameAsReq']?.value === true ? false : true,
			isRequired: (s, e) => s?.['payUnit.isSameAsReq']?.value === true ? false : true,
			section: '4',
			cols: { lg: 6 }
		},

		note: {
			type: 'textarea',
			label: 'Note for Receiving Lab',
			section: '5',
			config: {
				max: 999
			},
			info: 'Any additional information that should be included with the requisition for the receiving lab',
		}
	}, {
		lang,
		id,
		labs: labsData?.labs || [],
		users: userData?.users || [],
		groupId,
		clinicId,
		manuallyAddedContactPerson,
		setManuallyAddedContactPerson
	});

	return <FormV2 data={form} lang={lang} isLoadingExternalState={isLoadingLabs || isLoadingUsers} />;
}

/**
 * 
 * @param {import('../../../form-v2/types').FormV2FieldProps} props  
 */
const AnalysesCustomComponent = (props) => {
	const [list, setList] = useState([])
	const { data, isLoading } = useFetchData(props?.data?.state?.['labId']?.value ? `/integrations/clinic/labportalen/analyses/${props.data.externalState?.groupId}?lab_id=${props?.data?.state?.['labId']?.value}` : null); // analyses: LabPortalenAnalysis[]

	useEffect(() => {
		if (data?.analyses && Array.isArray(data.analyses)) {
			setList(data.analyses);
		} else {
			setList([]);
		}
	}, [data])

	return <div
		className={`lp-eremiss-analyses-container ${isLoading ? 'lp-eremiss-analyses-container_loading' : !props?.data?.state?.['labId']?.value || list.length <= 0 ? 'lp-eremiss-analyses-container_placeholder' : 'lp-eremiss-analyses-container_list'}`}
	>
		{isLoading ? <div key='loading' style={{
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			height: '100%',
			width: '100%'
		}}>
			<Player
				autoplay={true}
				loop={true}
				src="/lf30_editor_l5cxzdyf.json"
				style={{ height: "128px", width: "128px" }}
			/>
		</div> : props?.data?.state?.['labId']?.value ? <>
			{list.length > 0 ? <ul key='list'>
				{list.map(analysis => {
					const isSelected = props.value?.find?.(a => a?.AnalysisCode === analysis.AnalysisCode);

					return <li key={analysis.AnalysisCode} className={isSelected ? 'lp-eremiss-analyses-checkbox-selected' : ''}>
						<Field
							data={props.data}
							fieldName={props.fieldName}
							lang={props.lang}
							refresh={props.refresh}
							isSubmitting={props.isSubmitting}
							_singleField={{
								type: 'checkbox',
								label: analysis.AnalysisName,
								id: analysis.AnalysisCode,
								fieldState: {
									value: isSelected ? true : false,
									hasError: false,
									isTouched: false,
									isValid: true,
									errorMessage: null
								},
								handleChange: (o => {
									if (o?.value === true) {
										const newValue = [
											...(props.value || []),
											analysis
										];
										props.onChange(newValue);
									} else {
										const newValue = (props.value || []).filter(a => a?.AnalysisCode !== analysis.AnalysisCode);
										props.onChange(newValue);
									}
								})
							}}
						/>
					</li>
				})}
			</ul> : <p>
				{'No available analyses for this lab'.translate(props.lang)}
			</p>}
		</> : <p>
			{'Please select a lab to load available analyses'.translate(props.lang)}
		</p>}
	</div>
}

/**
 * @typedef {{
 *   AnalysisName: string;
 *   AnalysisCode: string;
 *   QuestionIds: string[];
 * }} LabPortalenAnalysis
 */